import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { darkTheme, lightTheme } from './themes';

export const themesModule = createFrontendModule({
  pluginId: 'app',
  extensions: [lightTheme, darkTheme],
});
